import { render, staticRenderFns } from "./school.vue?vue&type=template&id=437acb34&scoped=true&"
import script from "./school.vue?vue&type=script&lang=ts&"
export * from "./school.vue?vue&type=script&lang=ts&"
import style0 from "./school.vue?vue&type=style&index=0&id=437acb34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437acb34",
  null
  
)

export default component.exports